import {RouteName} from '@toolify/client/src/setup/router/enum/RouteName'
import {getDatabaseItemRouteSource} from '@toolify/client/src/modules/databases/functions/getDatabaseItemRouteSource'

interface IRouteLocationLike {
  name?: unknown
  params: Record<string, unknown>
  query: Record<string, unknown>
}

interface IGetCanShowDatabaseItemLayerInSidebarParams {
  layerRoute: IRouteLocationLike | null | undefined
  baseRoute: IRouteLocationLike | null | undefined
  layerCount: number
  isSmallScreen: boolean
}

// An opened item keeps its address in every layout. The sidebar belongs to the database page, so the item layer can
// hand its item to that sidebar only while it is the one layer over the database page it was opened from, from a view.
export function getCanShowDatabaseItemLayerInSidebar({
  layerRoute,
  baseRoute,
  layerCount,
  isSmallScreen,
}: IGetCanShowDatabaseItemLayerInSidebarParams): boolean {
  if(isSmallScreen || layerCount !== 1 || layerRoute?.name !== RouteName.DatabaseItem) {
    return false
  }
  const source = getDatabaseItemRouteSource(layerRoute)
  if(!source.viewId || layerRoute.query.formViewId) {
    return false
  }
  const isDatabasePage = baseRoute?.name === RouteName.Database || baseRoute?.name === RouteName.DatabaseView
  return isDatabasePage && baseRoute.params.databaseId === source.databaseId
}
